import React from 'react';
import './Bulbcoverprodtabl.css';

const Bulbcoverprodtabl = () => {
    return (
        <div className="mold-container">
            <h2 className="heading">Take a look at the video to learn how LED bulb covers are produced</h2>
            <p><strong>Case for reference:</strong></p>
            <div className="details-grid">
                <div className="left-column">
                    <p><strong>Machine Model</strong> </p>
                    <p><strong>Product</strong> </p>
                    <p><strong>Material</strong></p>
                    <p><strong>Cycle Time</strong></p>
                    <p><strong>Cavity</strong></p>
                </div>
                <div className="right-column">
                    <p>Powerjet IBM200R-S6</p>
                    <p>A95 Light Bulb</p>
                    <p>PC</p>
                    <p>22s</p>
                    <p>4 Cavities</p>
                </div>
            </div>
        </div>
    );
};

export default Bulbcoverprodtabl;
